export default {
  methods: {
    getRecurringTypeLabel (type) {
      if (!type) return ''
      return type.description ? this.$t(type.description) : type.name
    }
  }
}
